import styled from "styled-components";

export const LogoStyled = styled.img`
  width: auto;
  height: ${({ height }) => height || "2.4375rem"};
`;
